import React, {useState} from "react";
import {useForm} from 'react-hook-form'
import {useLocation} from "react-router-dom";
import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl, FormErrorMessage,
    FormLabel,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightElement, Link,
    Text,
    useColorModeValue, useToast,
} from "@chakra-ui/react";
import DefaultAuth from "layouts/auth/Default";
import illustration from "assets/img/auth/landingpage-background.jpg";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import {RiEyeCloseLine} from "react-icons/ri";
import {postData} from "../../../services/api";
import Footer from "../../../components/footer/FooterAuth";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

function Register() {

    const toast = useToast()
    const MySwal = withReactContent(Swal)

    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";
    const textColorBrand = useColorModeValue("brand.500", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);

    const {
        handleSubmit,
        register,
        formState: {errors, isSubmitting},
    } = useForm()

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const source = queryParams.get('source');

    function onSubmit(values) {

        return new Promise(async (resolve) => {
            try {
                if (source) {
                    values.source = source;
                }

                await postData('/api/register', values);

                toast({
                    title: 'Account wurde erstellt',
                    status: 'success',
                    isClosable: true,
                })

                setSuccess(true)

                resolve();
            } catch (error) {

                if (error.response && error.response.status === 422) {
                    const errors = error.response.data.errors;
                    if (errors.email) {
                        MySwal.fire({
                            title: <p>Emailadresse bereits registriert</p>,
                            html: <p>Ein Benutzerkonto mit dieser Emailadresse existiert bereits. Bitte nutze diese
                                Emailadresse um dich einzuloggen. Mit Klick auf den Button gelangst du zum Login.</p>,
                            confirmButtonText: 'Zum Login',
                            icon: 'info',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.href = '#/auth/login';
                            }
                        })
                    } else {
                        toast({
                            title: 'Es ist ein Fehler bei der Registrierung aufgetreten',
                            status: 'error',
                            isClosable: true,
                        })
                    }
                } else {
                    toast({
                        title: 'Es ist ein Fehler bei der Registrierung aufgetreten',
                        status: 'error',
                        isClosable: true,
                    })
                }

                resolve();
            }
        })
    }

    const handleClick = () => setShow(!show);
    return (
        <Box>
            <DefaultAuth illustrationBackground={illustration} image={illustration}>
                {/*<NavLink*/}
                {/*    to='/auth/login'*/}
                {/*    style={() => ({*/}
                {/*        width: "fit-content",*/}
                {/*        marginTop: "40px",*/}
                {/*    })}>*/}
                {/*    <Flex*/}
                {/*        align='center'*/}
                {/*        ps={{base: "25px", lg: "0px"}}*/}
                {/*        pt={{lg: "0px", xl: "0px"}}*/}
                {/*        w='fit-content'>*/}
                {/*        <Icon*/}
                {/*            as={FaChevronLeft}*/}
                {/*            me='12px'*/}
                {/*            h='13px'*/}
                {/*            w='8px'*/}
                {/*            color='secondaryGray.600'*/}
                {/*        />*/}
                {/*        <Text ms='0px' fontSize='sm' color='secondaryGray.600'>*/}
                {/*            Zum Login*/}
                {/*        </Text>*/}
                {/*    </Flex>*/}
                {/*</NavLink>*/}
                <Flex
                    maxW={{base: "100%", md: "500px"}}
                    w={{base: "100%", md: "40vw"}}
                    mx={{base: "auto", lg: "0px"}}
                    me='auto'
                    h='100%'
                    alignItems='start'
                    justifyContent='center'
                    mb={{base: "30px", md: "60px"}}
                    px={{base: "25px", md: "0px"}}
                    mt={{base: "40px", md: "14vh"}}
                    flexDirection='column'>
                    <Box me='auto'>
                        <Heading color={textColor} fontSize='36px' mb='10px'>
                            Registrierung
                        </Heading>
                        <Text
                            mb='36px'
                            ms='4px'
                            color={textColorSecondary}
                            fontWeight='400'
                            fontSize='md'
                        >
                            Kostenlos und unverbindlich registrieren. Bist du schon registriert, dann geht es
                            <Link href="#/auth/login" color={textColorBrand} ml={1}>hier zur Anmeldung</Link>.
                        </Text>
                    </Box>
                    {success ? (
                        <Text
                            fontWeight='400'
                            fontSize='md'
                            w={{base: "100%", md: "420px"}}
                        >
                            Dein Account wurde erfolgreich angelegt. Wir haben Dir eine Email zur Bestätigung der
                            Anmeldung gesendet. Bitte folge den Anweisungen in der Email.
                        </Text>
                    ) : (
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Flex
                                zIndex='2'
                                direction='column'
                                w={{base: "100%", md: "420px"}}
                                maxW='100%'
                                borderRadius='15px'
                                mx={{base: "auto", lg: "unset"}}
                                me='auto'
                                mb={{base: "20px", md: "auto"}}>
                                <Flex justifyContent='space-between' gap='15px' align='center' mb='24px'
                                      direction={{base: "column", lg: 'row'}}>
                                    <FormControl isInvalid={errors?.firstname}>
                                        <FormLabel
                                            display='flex'
                                            ms='4px'
                                            fontSize='md'
                                            fontWeight='500'
                                            color={textColor}
                                            htmlFor='firstname'
                                        >
                                            Vorname<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Input
                                            id='firstname'
                                            fontSize='md'
                                            ms={{base: "0px", md: "0px"}}
                                            type='text'
                                            fontWeight='500'
                                            size='lg'
                                            {...register('firstname', {
                                                required: 'Bitte gib einen Vornamen an',
                                            })}
                                        />
                                        <FormErrorMessage>{errors?.firstname?.message}</FormErrorMessage>
                                    </FormControl>
                                    <FormControl isInvalid={errors?.lastname}>
                                        <FormLabel
                                            display='flex'
                                            ms='4px'
                                            fontSize='sm'
                                            fontWeight='500'
                                            color={textColor}
                                            htmlFor='lastname'
                                        >
                                            Nachname<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Input
                                            id='lastname'
                                            fontSize='md'
                                            ms={{base: "0px", md: "0px"}}
                                            type='text'
                                            fontWeight='500'
                                            size='lg'
                                            {...register('lastname', {
                                                required: 'Bitte gib einen Nachnamen an',
                                            })}
                                        />
                                        <FormErrorMessage>{errors?.lastname?.message}</FormErrorMessage>
                                    </FormControl>
                                </Flex>

                                <FormControl isInvalid={errors?.password} mb='24px'>
                                    <FormLabel
                                        ms='4px'
                                        fontSize='md'
                                        fontWeight='500'
                                        color={textColor}
                                        display='flex'
                                        htmlFor='password'
                                    >
                                        Passwort<Text color={brandStars}>*</Text>
                                    </FormLabel>
                                    <InputGroup size='md'>
                                        <Input
                                            id='password'
                                            fontSize='md'
                                            placeholder='Min. 8 Zeichen'
                                            size='lg'
                                            type={show ? "text" : "password"}
                                            {...register('password', {
                                                required: 'Bitte gib ein Passwort an',
                                                minLength: {
                                                    value: 8,
                                                    message: 'Das Passwort muss mindestens 8 Zeichen lang sein'
                                                },
                                            })}
                                        />
                                        <InputRightElement display='flex' alignItems='center' mt='4px'>
                                            <Icon
                                                color={textColorSecondary}
                                                _hover={{cursor: "pointer"}}
                                                as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                                onClick={handleClick}
                                            />
                                        </InputRightElement>
                                    </InputGroup>
                                    <FormErrorMessage>{errors?.password?.message}</FormErrorMessage>
                                </FormControl>

                                <FormControl mb="24px" isInvalid={errors?.email}>
                                    <FormLabel
                                        htmlFor='email'
                                        display='flex'
                                        ms='4px'
                                        fontSize='md'
                                        fontWeight='500'
                                        color={textColor}
                                    >
                                        Email<Text color={brandStars}>*</Text>
                                    </FormLabel>
                                    <Input
                                        id='email'
                                        fontSize='md'
                                        ms={{base: "0px", md: "0px"}}
                                        type='text'
                                        fontWeight='500'
                                        size='lg'
                                        {...register('email', {
                                            required: 'Bitte gib eine Email ein',
                                            pattern: {
                                                value: /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,4}$/,
                                                message: 'Bitte gib eine gültige Email-Adresse ein',
                                            },
                                        })}
                                    />
                                    <FormErrorMessage>{errors?.email?.message}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors?.consent}>
                                    <Box display='flex' alignItems='center'>
                                        <Checkbox
                                            id='consent'
                                            colorScheme='brandScheme'
                                            me='10px'
                                            {...register('consent', {
                                                required: 'Bitte akzeptiere die Allgemeinen Geschäftsbedingungen und Datenschutzbestimmungen',
                                            })}
                                        />
                                        <FormLabel
                                            htmlFor='consent'
                                            mb='0'
                                            fontWeight='normal'
                                            color={textColor}
                                            fontSize='sm'>
                                            Ich akzeptiere die <Link color={textColorBrand} target={'_blank'}
                                                                     href="https://www.ferienhaus.online/agbs">Allgemeinen
                                            Geschäftsbedingungen</Link> und stimme der Verarbeitung sowie Nutzung meiner
                                            Daten
                                            gemäß den <Link color={textColorBrand} target={'_blank'}
                                                            href="https://www.ferienhaus.online/datenschutz">Datenschutzbestimmungen</Link> von
                                            Ferienhaus.online zu.
                                        </FormLabel>
                                    </Box>
                                    <FormErrorMessage>{errors?.consent?.message}</FormErrorMessage>
                                </FormControl>

                                <Button
                                    fontSize='md'
                                    variant='brand'
                                    fontWeight='500'
                                    w='100%'
                                    h='50'
                                    mt='24px'
                                    mb='24px'
                                    isLoading={isSubmitting}
                                    type='submit'
                                >
                                    Kostenlos & Unverbindlich<br/>registrieren
                                </Button>
                            </Flex>
                        </form>
                    )}
                </Flex>
            </DefaultAuth>

            <Footer/>
        </Box>
    );
}

export default Register;
